import { useEffect, useState } from "react";
import { finalPriceAfterExtractingCommission } from "../../config/utils/finalPriceExtractingCommission";

const CustomPriceField = ({ onChange, commissionPercentage }) => {

    const [priceValue, setPriceValue] = useState(null);
    const [calculatedActualPrice, setCalculatedActualPrice] = useState(0);

    useEffect(() => {
        if (priceValue) {
            setCalculatedActualPrice(finalPriceAfterExtractingCommission(priceValue, commissionPercentage))
        }
    }, [priceValue])

    const priceValueHandler = (event) => {
        setPriceValue(event.target.value);
        onChange(event.target.value)
    }

    return (
        <div className='w-full flex flex-col items-start gap-3'>
            <input value={priceValue} placeholder='£50.99' onChange={priceValueHandler} className='w-full flex items-center shadow-md p-3 rounded-md border hover:border-gray-600 transition' />
            {/* {
                priceValue &&
                <p className='text-base text-start'>Final Earnings: <span className='text-red-500'>£ {calculatedActualPrice.toFixed(2)}</span>{commissionPercentage > 0 && ' (after commission deduction) '}</p>
            } */}
        </div>

    )
}

export default CustomPriceField